import styled from 'styled-components';
import { theme, Column, Row } from '@dls/web';

export const EquipmentImgRow = styled.div`
  width: 10rem;
`;

export const ModalContainer = styled.div`
  max-height: 50vh;
  overflow-y: auto;
`;

export const CardTop = styled(Column)`
  padding-top: ${theme.space[8]}px;
`;

export const StyledRow = styled(Row)`
width:100%
`;

export const PaddingDiv = styled.div`
padding: ${theme.space[2]}px;
`;

export const SpaceDiv = styled(Row)`
margin-top: ${theme.space[6]}px;
margin-bottom: ${theme.space[6]}px;
`;

export const StyledMargin = styled(Row)`
margin-top:2%;
`;

export const DownloadContainer = styled(Row)`
margin-left: ${theme.space[2]}px;
margin-bottom: ${theme.space[10]}px;
`;

export const SpaceMargin = styled.div`
margin-top:2%;
margin-left:2%;
`;

export const RowLeftMargin = styled(Row)`
margin-left: ${theme.space[4]}px;
`;

export const ImageContainer = styled.div`
  position: relative;
  &:hover .title{
    z-index: 0;
  }
`;

export const ImageDownload = styled.div`
  background-color: rgb(255, 255, 255, 0.4);
  position: absolute;
  bottom: 0;
  color: white;
  width: 100%;
  font-size: 25px;
  padding: 15px 0;
  text-align: center;
  z-index: -1;
  transition: 0.8s;
`

export const ImageBlurPreview = styled.div`
  ${(p) => p.blur && `filter: blur(8px);`}
`;